<template>
  <div class="pt-12 lg:pt-24 pb-6 lg:pb-24 flex justify-center lg:justify-start w-full" v-if="top_10.length">
    <div class="podium-not-first translate-x-2 w-full" :class="{ 'is-user': podium[1].is_user }">
      <span class="top"></span>
      <i v-html="$icons.silver" class="absolute -top-14 scale-75 lg:scale-100 badge"></i>
      <div class="relative text-xs lg:text-sm font-bold h-8 w-full text-center">
        <span> 2º </span>
        <span class="text-ontick-blue-600"> {{ podium[1].code }} </span>
        <span
          class="w-full h-0.5 bg-gradient-to-r from-transparent via-ontick-steel-100 to-transparent absolute bottom-0 left-0"
        ></span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold">
        <PnlIndicatorComponent :pnl="podium[1].result" />
        <span class="text-sm lg:text-xl whitespace-nowrap">
          {{ podium[1].result | currency }}
        </span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold text-sm">
        <i v-html="otp_badge" class="scale-150"></i>
        <span> {{ podium[1].bests }} </span>
      </div>
    </div>

    <div class="podium-first w-full" :class="{ 'is-user': podium[0].is_user }">
      <span class="top"></span>
      <i v-html="$icons.gold" class="absolute -top-14 lg:scale-125 badge"></i>
      <div class="relative text-xs lg:text-sm font-bold h-8 w-full text-center">
        <span> 1º </span>
        <span class="text-ontick-blue-600"> {{ podium[0].code }} </span>
        <span
          class="w-full h-0.5 bg-gradient-to-r from-transparent via-ontick-yellow-600 to-transparent absolute bottom-0 left-0"
        ></span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold">
        <PnlIndicatorComponent :pnl="podium[0].result" />
        <span class="text-sm lg:text-xl whitespace-nowrap">
          {{ podium[0].result | currency }}
        </span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold text-sm">
        <i v-html="otp_badge" class="scale-150"></i>
        <span> {{ podium[0].bests }} </span>
      </div>
    </div>

    <div class="podium-not-first -translate-x-2 w-full" :class="{ 'is-user': podium[2].is_user }">
      <span class="top"></span>
      <i v-html="$icons.bronze" class="absolute -top-14 scale-75 lg:scale-100 badge"></i>
      <div class="relative text-xs lg:text-sm font-bold h-8 w-full text-center">
        <span> 3º </span>
        <span class="text-ontick-blue-600"> {{ podium[2].code }} </span>
        <span
          class="w-full h-0.5 bg-gradient-to-r from-transparent via-ontick-orange-600 to-transparent absolute bottom-0 left-0"
        ></span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold">
        <PnlIndicatorComponent :pnl="podium[2].result" />
        <span class="text-sm lg:text-xl whitespace-nowrap">
          {{ podium[2].result | currency }}
        </span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold text-sm">
        <i v-html="otp_badge" class="scale-150"></i>
        <span> {{ podium[2].bests }} </span>
      </div>
    </div>
  </div>
  <div class="pt-12 lg:pt-24 pb-6 lg:pb-24 flex justify-center lg:justify-start w-full" v-else>
    <div class="podium-not-first translate-x-2 w-full">
      <span class="top"></span>
      <i v-html="$icons.silver" class="absolute -top-14 scale-75 lg:scale-100 badge"></i>
      <div class="relative text-xs lg:text-sm font-bold h-8 w-full text-center">
        <span> 2º </span>
        <span class="text-gray-500"> - </span>
        <span
          class="w-full h-0.5 bg-gradient-to-r from-transparent via-ontick-steel-100 to-transparent absolute bottom-0 left-0"
        ></span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold">
        <span class="text-sm lg:text-xl whitespace-nowrap text-gray-500"> - </span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold text-sm text-gray-500">
        <i v-html="otp_badge" class="scale-150"></i>
        <span> R$ - </span>
      </div>
    </div>

    <div class="podium-first w-full">
      <span class="top"></span>
      <i v-html="$icons.gold" class="absolute -top-14 lg:scale-125 badge"></i>
      <div class="relative text-xs lg:text-sm font-bold h-8 w-full text-center">
        <span> 1º </span>
        <span class="text-gray-500"> - </span>
        <span
          class="w-full h-0.5 bg-gradient-to-r from-transparent via-ontick-yellow-600 to-transparent absolute bottom-0 left-0"
        ></span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold">
        <span class="text-sm lg:text-xl whitespace-nowrap text-gray-500"> - </span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold text-sm text-gray-500">
        <i v-html="otp_badge" class="scale-150"></i>
        <span> R$ - </span>
      </div>
    </div>

    <div class="podium-not-first -translate-x-2 w-full">
      <span class="top"></span>
      <i v-html="$icons.bronze" class="absolute -top-14 scale-75 lg:scale-100 badge"></i>
      <div class="relative text-xs lg:text-sm font-bold h-8 w-full text-center">
        <span> 3º </span>
        <span class="text-gray-500"> - </span>
        <span
          class="w-full h-0.5 bg-gradient-to-r from-transparent via-ontick-orange-600 to-transparent absolute bottom-0 left-0"
        ></span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold">
        <span class="text-sm lg:text-xl whitespace-nowrap text-gray-500"> - </span>
      </div>
      <div class="flex items-center justify-center gap-2 font-bold text-sm text-gray-500">
        <i v-html="otp_badge" class="scale-150"></i>
        <span> R$ - </span>
      </div>
    </div>
  </div>
</template>

<script>
import otp_badge from "../assets/otp_badge";
import PnlIndicatorComponent from "./pnl-indicator.component.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    PnlIndicatorComponent,
  },

  props: {
    top_10: {
      type: Array,
    },
  },

  data() {
    return {
      otp_badge,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    podium() {
      return this.top_10.slice(0, 3).map((item) => {
        return {
          ...item,
          is_user: item.code == this.getSelectedAccount.user_code,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.podium {
  &-first {
    @apply z-10 relative text-gray-50 bg-gradient-to-b from-ontick-steel-500 to-ontick-carbon-500 px-2 lg:px-4 pt-8 pb-12 flex items-center flex-col gap-4;
    div {
      @apply z-10;
    }
    &.is-user {
      &::before {
        @apply bg-gradient-to-b from-[#03507D] to-transparent opacity-50 inset-0 absolute #{!important};
        content: "";
      }
      .top::before {
        @apply bg-[#0694E61A] absolute inset-0;
        content: "";
      }
    }
    .top {
      @apply absolute h-6 -top-6 bg-gradient-to-b from-ontick-steel-500 to-ontick-carbon-500 w-full;
      clip-path: polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%);
    }
  }
  &-not-first {
    @apply max-h-[175px] relative translate-y-4 text-gray-50 bg-gradient-to-b from-ontick-graphite-500 to-ontick-carbon-500 px-2 lg:px-4 py-8 flex items-center flex-col gap-4;
    div {
      @apply z-10;
    }
    &.is-user {
      &::before {
        @apply bg-gradient-to-b from-[#03507D] to-transparent opacity-50 inset-0 absolute #{!important};
        content: "";
      }
      .top::before {
        @apply bg-[#0694E61A] absolute inset-0;
        content: "";
      }
    }
    .top {
      @apply absolute h-6 -top-6 bg-gradient-to-b from-ontick-steel-500 to-ontick-carbon-500 w-full;
      clip-path: polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%);
    }
  }
}
.is-user {
  .badge {
    filter: drop-shadow(0px 0px 4px #07a4ff);
  }
}
</style>
